import { gql } from '@apollo/client';

export const GET_USERS_GROUPS = gql`
  query UserGroups {
    userGroups {
      uuid
      title
    }
  }
`;
